import ServerApi from "./../../../libs/api-services/server-api"

class ThermalService extends ServerApi {
  URL_PREFIX = "/v1/secure/user/thermals/"
}

export const thermalService = new ThermalService()
